"use client";
import React, { useEffect } from "react";
import DrinkTypeCard from "../drinkTypeCard/DrinkTypeCard";
import AlcoholicDrinkData from "@/mock/AlcoholicDrinkData";
import { Button } from "@/shared";
import { ContextProps, useGlobalContext } from "@/contexts/AppContext";
import { usePathname, useRouter } from "next/navigation";
import styles from "./Alcohol.module.scss";
import useFetchCategoryProducts from "@/hooks/products/useFetchCategoryProducts";
import { useSelector } from "react-redux";
import { AppState } from "@/store/configureStore";

const AlcoholicDrinksCard = () => {
	const { theme }: ContextProps = useGlobalContext();
	const router = useRouter();
	const route = usePathname();
	const checkRoute = route.includes("/categories");
	const { fetchAlcoholicCategories } = useFetchCategoryProducts();
	const categories = useSelector((state: AppState) => state.categoryProduct.categories);

	useEffect(() => {
		fetchAlcoholicCategories();
		// fetchBrands();
	}, []);
	const bgColors = ["#FCEDC5", "#F8D5C5", "#FFECEB", "#E0F1CC"];

	return (
		<div className={styles.wrapper} data-route={checkRoute}>
			<div data-route={checkRoute} className={styles.container}>
				{checkRoute
					? AlcoholicDrinkData?.map(({ id, icon,text, bgdark }: any) => {
							return (
								<DrinkTypeCard
								key={id}
								id={id}
								icon={icon}
								bg={bgdark}
								text={text}
									cardType="categories"
								/>
							);
					  })
					: AlcoholicDrinkData?.slice(0, 4).map(({ id, icon,text, bgdark }: any, index: number) => {
							return (
								<DrinkTypeCard
								key={id}
								id={id}
								icon={icon}
								bg={bgdark}
								text={text}
								/>
							);
					  })}
			</div>
			<Button
				buttonType="primary"
				onClick={() => router.push("/alcohol/categories")}
				className={styles.btn}
			>
				<h3>See All Categories</h3>
			</Button>
		</div>
	);
};

export default AlcoholicDrinksCard;
